import { Text, TextType } from 'ui-components/components/text';
import { FlexColumn } from 'ui-components/components/flex/column';
import { Gap } from 'ui-components/components/flex/gap';
import { CopyToClipboardButton } from 'ui-components/components/copy-to-clipboard-button/copy-to-clipboard-button';

import type { LtlShipment, LtlBookingConfirmation } from '@shipstation/client-common/types/ltl';
import { confirmationCardMessages } from './confirmation-card-messages';

import style from './confirmation-cards.module.less';

type TrackingCardProps = {
  shipmentDetails: LtlShipment;
  bookingConfirmation: LtlBookingConfirmation | null;
};

const STATUS_BOOKED = 'Booked';
const STATUS_CANCELLED = 'Cancelled';

const getStatusClassName = (status: string): string => {
  if (status === STATUS_BOOKED) return style['status-booked'];
  if (status === STATUS_CANCELLED) return style['status-cancelled'];
  return '';
};

export const TrackingCard = ({ shipmentDetails, bookingConfirmation }: TrackingCardProps) => (
  <div className={style['card']}>
    <div className={style['card-header']}>
      <Text isBold textType={TextType.H4} value={confirmationCardMessages.trackingHeader} />
    </div>
    <div className={style['card-body']}>
      <FlexColumn gap={Gap.Space8}>
        {shipmentDetails.status && (
          <FlexColumn gap={Gap.Space4}>
            <Text className={style['detail-label']} textType={TextType.Label} value={confirmationCardMessages.statusLabel} />
            <span className={`${style['status-badge']} ${getStatusClassName(shipmentDetails.status)}`}>{shipmentDetails.status}</span>
          </FlexColumn>
        )}
        {shipmentDetails.bolNumber && (
          <FlexColumn gap={Gap.Space4}>
            <Text className={style['detail-label']} textType={TextType.Label} value={confirmationCardMessages.bolNumberLabel} />
            <div className={style['bol-value']}>
              <Text textType={TextType.Paragraph} value={shipmentDetails.bolNumber} />
              <CopyToClipboardButton
                textToCopy={shipmentDetails.bolNumber}
                tooltipMessageDescriptor={confirmationCardMessages.copyBolNumber}
              />
            </div>
          </FlexColumn>
        )}
        {shipmentDetails.proNumber && (
          <FlexColumn gap={Gap.Space4}>
            <Text className={style['detail-label']} textType={TextType.Label} value={confirmationCardMessages.proNumberLabel} />
            <Text textType={TextType.Paragraph} value={shipmentDetails.proNumber} />
          </FlexColumn>
        )}
        {shipmentDetails.confirmationNumber && (
          <FlexColumn gap={Gap.Space4}>
            <Text className={style['detail-label']} textType={TextType.Label} value={confirmationCardMessages.confirmationNumberLabel} />
            <Text textType={TextType.Paragraph} value={shipmentDetails.confirmationNumber} />
          </FlexColumn>
        )}
        {bookingConfirmation?.pickupConfirmationNumber && (
          <FlexColumn gap={Gap.Space4}>
            <Text className={style['detail-label']} textType={TextType.Label} value={confirmationCardMessages.pickupConfirmationLabel} />
            <Text textType={TextType.Paragraph} value={bookingConfirmation.pickupConfirmationNumber} />
          </FlexColumn>
        )}
      </FlexColumn>
    </div>
  </div>
);
